import { type Document } from '@contentful/rich-text-types';
import {
  documentToReactComponents,
  type Options
} from '@contentful/rich-text-react-renderer';

type ContentfulDocumentProps = {
  document: Document;
  options?: Options;
};

export const ContentfulDocument = ({
  document,
  options
}: ContentfulDocumentProps) =>
  documentToReactComponents(document, {
    renderText: (text) =>
      text.split('\n').flatMap((text, i) => [i > 0 && <br />, text]),
    ...options
  });
